/** Product Experience V3 — motion system */

export const V3_MOTION = {
  /**
   * Route content enter — a quick opacity fade only (no blur, no slide, no
   * exit wait) so nav and headers never flash on a tab click.
   */
  pageContent: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.14, ease: [0.22, 1, 0.36, 1] as const },
  },
  /** Page enter */
  page: {
    initial: { opacity: 0, y: 12, filter: 'blur(4px)' },
    animate: { opacity: 1, y: 0, filter: 'blur(0px)' },
    exit: { opacity: 0, y: -8, filter: 'blur(2px)' },
    transition: { duration: 0.38, ease: [0.22, 1, 0.36, 1] as const },
  },
  /** Staggered children */
  stagger: {
    container: {
      animate: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
    },
    item: {
      initial: { opacity: 0, y: 16 },
      animate: { opacity: 1, y: 0 },
      transition: { duration: 0.42, ease: [0.22, 1, 0.36, 1] as const },
    },
  },
  /** Phase switch */
  phase: {
    initial: { opacity: 0, scale: 0.98 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] as const },
  },
  /** Metric count-up feel */
  metric: {
    initial: { opacity: 0, scale: 0.92 },
    animate: { opacity: 1, scale: 1 },
    transition: { type: 'spring' as const, stiffness: 260, damping: 22 },
  },
  /** Workflow pill */
  pill: {
    whileHover: { scale: 1.03, y: -1 },
    whileTap: { scale: 0.97 },
    transition: { type: 'spring' as const, stiffness: 400, damping: 28 },
  },
  /** Ambient orb pulse */
  orb: {
    animate: {
      scale: [1, 1.08, 1],
      opacity: [0.35, 0.55, 0.35],
    },
    transition: { duration: 6, repeat: Infinity, ease: 'easeInOut' as const },
  },
  /** Progress bar */
  progress: {
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] as const },
  },
} as const;

export const V3_DURATION = {
  fast: 0.15,
  normal: 0.32,
  slow: 0.55,
  page: 0.38,
} as const;
